export default "__VITE_PUBLIC_ASSET__2055e47d__"